import Vue from 'vue';
import { downloadBlobFile } from '@/utils/download';
export const detailConfigs = {
  gailanzuoye: [
    {
      prop: 'rank',
      label: '综合排名',
      min_width: '147',
      fixed: 'left',
    },
    {
      prop: 'rate',
      label: '名次占比',
      width: '113',
    },
    {
      prop: 'start_time',
      label: '开始时间',
      width: '131',
    }, {
      prop: 'end_time',
      label: '结束时间',
      width: '137',
    }, {
      prop: 'outsourcer',
      label: '供应商',
      // width:
    }, {
      prop: 'operator_name',
      label: '作业员',
      min_width: '225',
    }, {
      prop: 'cl_score',
      label: '作业产量得分',
      width: '140',
    }, {
      prop: 'xl_score',
      label: '制作效率得分',
      width: '164',
    }, {
      prop: 'zl_score',
      label: '验收一次缺陷率得分',
      min_width: '180',
    }, {
      prop: 'hs_score',
      label: '有效时长得分',
      min_width: '140',
    }, {
      prop: 'evaluation',
      label: '质量效率评价',
      width: '140',
    },
    {
      prop: 'cl_value',
      label: '作业产量',
      width: '140',
    },
    {
      prop: 'xl_value',
      label: '制作效率',
      width: '140',
    },
    {
      prop: 'zl_value',
      label: '验收一次缺陷率',
      width: '140',
    },
    {
      prop: 'hs_value',
      label: '有效时长',
      width: '140',
    },
    {
      prop: 'sum_hs',
      label: '出勤总耗时',
      width: '140',
    },
    {
      prop: 'hs_ratio',
      label: '产线耗时占比',
      width: '140',
    },
    {
      prop: 'score',
      label: '综合得分',
      fixed: 'right',
      width: '138',
    },
  ],
  gailanneijian: [
    {
      prop: 'rank',
      label: '综合排名',
      min_width: '147',
      fixed: 'left',
    },
    {
      prop: 'rate',
      label: '名次占比',
      width: '113',
    },
    {
      prop: 'start_time',
      label: '开始时间',
      width: '131',
    }, {
      prop: 'end_time',
      label: '结束时间',
      width: '137',
    }, {
      prop: 'outsourcer',
      label: '供应商',
      width: '90',
    }, {
      prop: 'operator_name',
      label: '内检员',
      min_width: '225',
    }, {
      prop: 'cl_score',
      label: '作业产量得分',
      width: '140',
    }, {
      prop: 'xl_score',
      label: '制作效率得分',
      width: '164',
    }, {
      prop: 'zl_score',
      label: '验收一次缺陷率得分',
      min_width: '160',
    }, {
      prop: 'hs_score',
      label: '有效时长得分',
      min_width: '140',
    }, {
      prop: 'evaluation',
      label: '质量效率评价',
      width: '140',
    }, {
      prop: 'score',
      label: '综合得分',
      fixed: 'right',
      width: '138',
    },
  ],
  danxiangzuoye: [
    {
      prop: 'rank',
      label: '排名',
      fixed: 'left',
      min_width: '157',
      sortable: 'custom',
    }, {
      prop: 'outsourcer',
      label: '供应商',
      // width: 70
    }, {
      prop: 'operator_name',
      label: '作业员',
      min_width: '225',
    }, {
      prop: 'score',
      label: '分数',
      // width: 135
    },
    // {
    //   prop: 'standard',
    //   label: '标准值'
    // }, {
    //   prop: 'dbb',
    //   label: '达标比'
    // }
  ],
  danxiangneijian: [
    {
      prop: 'rank',
      label: '排名',
      fixed: 'left',
      min_width: '157',
      sortable: 'custom',
    }, {
      prop: 'outsourcer',
      label: '供应商',
      // width: 70
    }, {
      prop: 'operator_name',
      label: '内检员',
      min_width: '225',
    }, {
      prop: 'score',
      label: '分数',
      // width: 135
    },
    // {
    //   prop: 'standard',
    //   label: '标准值'
    // }, {
    //   prop: 'dbb',
    //   label: '达标比'
    // }
  ],
  zonghezuoye: [
    {
      prop: 'rank',
      label: '综合排名',
      fixed: 'left',
      sortable: 'custom',
      min_width: '145',
    }, {
      prop: 'outsourcer',
      label: '供应商',
      // width: 70
    }, {
      prop: 'operator_name',
      label: '作业员',
      min_width: '225',
    }, {
      prop: 'score',
      label: '综合分数',
      min_width: '100',
    },
  ],
  zongheneijian: [
    {
      prop: 'rank',
      label: '综合排名',
      fixed: 'left',
      sortable: 'custom',
      min_width: '145',
    }, {
      prop: 'outsourcer',
      label: '供应商',
      // width: 70
    }, {
      prop: 'operator_name',
      label: '内检员',
      min_width: '225',

    }, {
      prop: 'score',
      label: '综合分数',
    },
  ],
  neijian: [
    {
      name: 'time',
      label: '时间',
    },
    {
      name: 'cl',
      label: '内检产量',
    },
    {
      name: 'xl',
      label: '内检效率',
    },
    {
      name: 'zl',
      label: '内检人员缺陷率',
      width: 150,
    },
    {
      name: 'hs',
      label: '内检有效时长',
    },
    {
      name: 'cl_dbb',
      label: '产量达标比',
    },
    {
      name: 'xl_dbb',
      label: '效率达标比',
    },
    {
      name: 'zl_dbb',
      label: '质量达标比',
    },
    {
      name: 'hs_dbb',
      label: '有效时长比',
    },
    {
      name: 'total_score',
      label: '综合得分',
    },
  ],
};

export const radarExtend = {
  radar: {
    shape: 'polygon',
    indicator: [
      {
        name: '质量\n(100)',
        max: 100,
      },
      {
        name: '效率\n(100)',
        max: 100,
      },
      {
        name: '产量\n(100)',
        max: 100,
      },
      {
        name: '有效\n时长\n(100)',
        max: 100,
      },
    ],
    axisLine: {
      show: false,
    },
    splitNumber: 4,
    splitArea: {
      areaStyle: {
        color: ['#FFF'],
      },
    },
    splitLine: {
      lineStyle: {
        type: 'dashed',
      },
    },
  },
  // color: ['#334FC5', '#FFF4F1'],
  series: {
    name: 'radar',
    type: 'radar',
    lineStyle: {
      color: '#4D5EAA',
      width: 2,
    },
    // data: [
    //   {
    //     label: {
    //       show: true
    //     }
    //   },
    //   {
    //     label: {
    //       show: true
    //     },
    //     lineStyle: {
    //       type: 'dashed',
    //       color: '#f00'
    //     },
    //     symbolSize: 5
    //   }
    // ],
    tooltip: {
      // formatter: (params, tick) : {
      //   console.log(tick)
      //   return params.value[0]
      // }
    },
    symbolSize: 6,
  },
};

export const bus = new Vue();

export async function exportTable(params, fun) {
  const data = await fun(params);
  downloadBlobFile(data);
}

/* ${nbsp}${nbsp}1.内业：在制作环节，首次提交完成任务的mark数之和，仅计算人工作业的mark，不包括自动化融合成功的mark</br>
${nbsp}${nbsp}&nbsp;&nbsp;&nbsp;中业：在制作环节，首次提交完成任务的mark数之和</br>
${nbsp}备注：以道路实采-大批为例</br> */
const nbsp = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
export const clScore = `
  产量得分：</br>
  ${nbsp}指标描述：每个人的实际产量（制作产量）对比产线标准产量的情况得分</br>
  ${nbsp}基本计算逻辑：</br>
  ${nbsp}${nbsp}1. 达标比=实际产量 /（产线标准产量*产线耗时占比）=达标比；</br>
  ${nbsp}${nbsp}&nbsp;&nbsp;&nbsp;&nbsp;PS：产线耗时占比 = 作业员在该产线出勤耗时/作业员当天出勤总耗时</br>
  ${nbsp}${nbsp}2.权重（20）*达标比系数=产量得分</br>
  ${nbsp}达标比与达标比系数对应关系：</br>
  ${nbsp}${nbsp}50%以下  20%</br>
  ${nbsp}${nbsp}50%-60%  30%</br>
  ${nbsp}${nbsp}60%-70%  40%</br>
  ${nbsp}${nbsp}70%-80%  50%</br>
  ${nbsp}${nbsp}80%-90%  60%</br>
  ${nbsp}${nbsp}90%-100%  70%</br>
  ${nbsp}${nbsp}100%-120%  80%</br>
  ${nbsp}${nbsp}120%-150%  85%</br>
  ${nbsp}${nbsp}150%-170%  90%</br>
  ${nbsp}${nbsp}170%-200%  95%</br>
  ${nbsp}${nbsp}200%以上  100%</br>
`;

// ${nbsp}${nbsp}1.内业：制作效率=人工核实量/内业净用时*8/1.2</br>
// ${nbsp}${nbsp}&nbsp;&nbsp;&nbsp;中业：制作效率=中业人工编辑mark量/中业编辑净用时*8/1.2</br>
// ${nbsp}备注：以道路实采-大批为例</br>
/*
  指标描述：每个人的实际产量对比产线标准产量的情况的得分
  产线耗时占比=作业员在该产线出勤耗时/作业员当天的出勤数
*/
export const xlScore = `
  效率得分：</br>
  ${nbsp}指标描述：每个人的实际效率（制作效率）对比产线标准效率的情况得分</br>
  ${nbsp}基本计算逻辑：</br>
  ${nbsp}${nbsp}1.达标比=实际效率/产线标准效率</br>
  ${nbsp}${nbsp}2.权重（30）*达标比系数=效率得分</br>
  ${nbsp}达标比与达标比系数对应关系：</br>
  ${nbsp}${nbsp}50%以下  20%</br>
  ${nbsp}${nbsp}50%-60%  30%</br>
  ${nbsp}${nbsp}60%-70%  40%</br>
  ${nbsp}${nbsp}70%-80%  50%</br>
  ${nbsp}${nbsp}80%-90%  60%</br>
  ${nbsp}${nbsp}90%-100%  70%</br>
  ${nbsp}${nbsp}100%-120%  80%</br>
  ${nbsp}${nbsp}120%-150%  85%</br>
  ${nbsp}${nbsp}150%-170%  90%</br>
  ${nbsp}${nbsp}170%-200%  95%</br>
  ${nbsp}${nbsp}200%以上  100%</br>
`;
// ${nbsp}${nbsp}1.验收一次缺陷率=总缺陷量（排除“空”等级缺陷）/总抽样mark量=实际质量</br>
// ${nbsp}备注：以道路实采-大批为例</br>
export const zlScore = `
  质量得分：</br>
  ${nbsp}指标描述：每个人的实际质量（验收一次缺陷率）对比产线标准质量的情况得分</br>
  ${nbsp}基本计算逻辑：</br>
  ${nbsp}${nbsp}1.达标比=产线标准质量/实际质量</br>
  ${nbsp}${nbsp}2.权重(40)*达标比系数=质量得分</br>
  ${nbsp}达标比与达标比系数对应关系：</br>
  ${nbsp}${nbsp}50%以下  20%</br>
  ${nbsp}${nbsp}50%-60%  30%</br>
  ${nbsp}${nbsp}60%-70%  40%</br>
  ${nbsp}${nbsp}70%-80%  50%</br>
  ${nbsp}${nbsp}80%-90%  60%</br>
  ${nbsp}${nbsp}90%-100%  70%</br>
  ${nbsp}${nbsp}100%-120%  80%</br>
  ${nbsp}${nbsp}120%-150%  85%</br>
  ${nbsp}${nbsp}150%-170%  90%</br>
  ${nbsp}${nbsp}170%-200%  95%</br>
  ${nbsp}${nbsp}200%以上  100%</br>
`;
// ${nbsp}${nbsp}1.内业：实际有效时长=制作耗时=内业净用时+内检返修净用时+质检返修净用时</br>
// ${nbsp}${nbsp}&nbsp;&nbsp;&nbsp;中业：实际有效时长=作业耗时=中业编辑净用时+内检返修净用时+质检返修净用时</br>
// ${nbsp}备注：以道路实采-大批为例</br>
export const hsScore = `
  有效时长得分：</br>
  ${nbsp}指标描述：每个人的实际有效时长（当天出勤总耗时）对比产线标准时长的得分情况</br>
  ${nbsp}基本计算逻辑</br>
  ${nbsp}${nbsp}1.达标比=实际有效时长/产线标准耗时</br>
  ${nbsp}${nbsp}2.权重（10）*达标比系数=有效时长得分</br>
  ${nbsp}达标比与达标比系数对应关系：</br>
  ${nbsp}${nbsp}50%以下  20%</br>
  ${nbsp}${nbsp}50%-60%  30%</br>
  ${nbsp}${nbsp}60%-70%  40%</br>
  ${nbsp}${nbsp}70%-80%  50%</br>
  ${nbsp}${nbsp}80%-90%  60%</br>
  ${nbsp}${nbsp}90%-100%  70%</br>
  ${nbsp}${nbsp}100%-110%  80%</br>
  ${nbsp}${nbsp}110%-120%  85%</br>
  ${nbsp}${nbsp}120%-130%  90%</br>
  ${nbsp}${nbsp}130%-140%  95%</br>
  ${nbsp}${nbsp}140%以上  100%</br>
`;
export const tooltipContent = `
  ${zlScore}
  </br></br>
  ${xlScore}
  </br></br>
  ${clScore}
  </br></br>
  ${hsScore}
  </br></br>
  剔除场景说明：</br>
  ${nbsp}1.综合得分特殊场景剔除：</br>
  ${nbsp}${nbsp}作业员效率、产量为none时，耗时有数据 (返修引起的耗时情况)，剔除当天该人员的耗时，再计算产线、供应商整体分数</br>
  ${nbsp}2.个人综合得分特殊场景剔除：</br>
  ${nbsp}${nbsp}1)质量无值，但是产量、效率、有效时长有值，质量得分补齐为满分
`;
export const clValueContent = `
  指标描述：每个人的实际产量（制作产量）情况<br/>
  基本计算逻辑：<br/>
  ${nbsp}内业：在制作环节，首次提交完成任务的mark数之和，支持导出（包含耗时），仅计算人工作业的mark，不包括自动化融合成功的mark。<br/>
  ${nbsp}中业：在制作环节，首次提交完成任务的mark数之和。<br/>
  备注：以道路实采-大批为例。
`;
export const xlValueContent = `
  指标描述：每个人的实际效率（制作效率）情况<br/>
  基本计算逻辑：<br/>
  ${nbsp}内业：制作效率=人工核实量/内业净用时*8/1.2。<br/>
  ${nbsp}中业：制作效率=中业人工编辑mark量/中业编辑净用时*8/1.2。<br/>
  备注：以道路实采-大批为例。
`;
export const zlValueContent = `
  指标描述：每个人的实际质量（验收一次缺陷率）情况<br/>
  基本计算逻辑：<br/>
  ${nbsp}1.验收一次缺陷率=总缺陷量（排除“空”等级缺陷）/总抽样mark量=实际质量<br/>
  备注：以道路实采-大批为例。
`;
export const hsValueContent = `
  指标描述：每个人的实际有效时长<br/>
  基本计算逻辑：<br/>
  ${nbsp}内业：实际有效时长=制作耗时=内业净用时+内检返修净用时+质检返修净用时<br/>
  ${nbsp}中业：实际有效时长=作业耗时=中业编辑净用时+内检返修净用时+质检返修净用时<br/>
  备注：以道路实采-大批为例。
`;
export const scoreContent = `
  综合分数=质量得分+效率得分+产量得分+有效时长得分
`;
// 指标描述：每个人的实际产量（制作产量）对比产线标准产量的情况得分</br>
// 基本计算逻辑：</br>
// ${nbsp}1.内业：在制作环节，首次提交完成任务的mark数之和，仅计算人工作业的mark，不包括自动化融合成功的mark</br>
// ${nbsp}&nbsp;&nbsp;&nbsp;中业：在制作环节，首次提交完成任务的mark数之和</br>
// ${nbsp}2.达标比=实际产量/产线标准产量</br>
// ${nbsp}3.权重（20）*达标比系数=产量得分</br>
// 达标比与达标比系数对应关系：</br>
// ${nbsp}60%以下  20%</br>
// ${nbsp}60%-80%  40%</br>
// ${nbsp}80%-100  60%</br>
// ${nbsp}100%-120%  80%</br>
// ${nbsp}120%-150%  90%</br>
// ${nbsp}150%-200%  95%</br>
// ${nbsp}200%以上  100%</br>
// 备注：以道路实采-大批为例</br>
export const clScoreContent = `
${nbsp}指标描述：每个人的实际产量（制作产量）对比产线标准产量的情况得分</br>
${nbsp}基本计算逻辑：</br>
${nbsp}${nbsp}1. 达标比=实际产量 /（产线标准产量*产线耗时占比）=达标比；</br>
${nbsp}${nbsp}&nbsp;&nbsp;&nbsp;&nbsp;PS：产线耗时占比 = 作业员在该产线出勤耗时/作业员当天出勤总耗时</br>
${nbsp}${nbsp}2.权重（20）*达标比系数=产量得分</br>
${nbsp}达标比与达标比系数对应关系：</br>
${nbsp}${nbsp}50%以下  20%</br>
${nbsp}${nbsp}50%-60%  30%</br>
${nbsp}${nbsp}60%-70%  40%</br>
${nbsp}${nbsp}70%-80%  50%</br>
${nbsp}${nbsp}80%-90%  60%</br>
${nbsp}${nbsp}90%-100%  70%</br>
${nbsp}${nbsp}100%-120%  80%</br>
${nbsp}${nbsp}120%-150%  85%</br>
${nbsp}${nbsp}150%-170%  90%</br>
${nbsp}${nbsp}170%-200%  95%</br>
${nbsp}${nbsp}200%以上  100%</br>
`;
// 指标描述：每个人的实际效率（制作效率）对比产线标准效率的情况得分</br>
// 基本计算逻辑：</br>
// ${nbsp}1.内业：制作效率=人工核实量/内业净用时*8/1.2</br>
// ${nbsp}&nbsp;&nbsp;&nbsp;中业：制作效率=中业人工编辑mark量/中业编辑净用时*8/1.2</br>
// ${nbsp}2.达标比=实际效率/产线标准效率</br>
// ${nbsp}3.权重（30）*达标比系数=效率得分</br>
// 达标比与达标比系数对应关系：</br>
// ${nbsp}60%以下  20%</br>
// ${nbsp}60%-80%  40%</br>
// ${nbsp}80%-100  60%</br>
// ${nbsp}100%-120%  80%</br>
// ${nbsp}120%-150%  90%</br>
// ${nbsp}150%-200%  95%</br>
// ${nbsp}200%以上  100%</br>
// 备注：以道路实采-大批为例</br>
export const xlScoreContent = `
  ${nbsp}指标描述：每个人的实际效率（制作效率）对比产线标准效率的情况得分</br>
  ${nbsp}基本计算逻辑：</br>
  ${nbsp}${nbsp}1.达标比=实际效率/产线标准效率</br>
  ${nbsp}${nbsp}2.权重（30）*达标比系数=效率得分</br>
  ${nbsp}达标比与达标比系数对应关系：</br>
  ${nbsp}${nbsp}50%以下  20%</br>
  ${nbsp}${nbsp}50%-60%  30%</br>
  ${nbsp}${nbsp}60%-70%  40%</br>
  ${nbsp}${nbsp}70%-80%  50%</br>
  ${nbsp}${nbsp}80%-90%  60%</br>
  ${nbsp}${nbsp}90%-100%  70%</br>
  ${nbsp}${nbsp}100%-120%  80%</br>
  ${nbsp}${nbsp}120%-150%  85%</br>
  ${nbsp}${nbsp}150%-170%  90%</br>
  ${nbsp}${nbsp}170%-200%  95%</br>
  ${nbsp}${nbsp}200%以上  100%</br>
`;
// 指标描述：每个人的实际质量（验收一次缺陷率）对比产线标准质量的情况得分</br>
// 基本计算逻辑：</br>
// ${nbsp}1.验收一次缺陷率=总缺陷量（排除“空”等级缺陷）/总抽样mark量=实际质量</br>
// ${nbsp}2.达标比=产线标准质量/实际质量</br>
// ${nbsp}3.权重(40)*达标比系数=质量得分</br>
// 达标比与达标比系数对应关系：</br>
// ${nbsp}60以下  20%</br>
// ${nbsp}60%-80%  40%</br>
// ${nbsp}80%-100%  60%</br>
// ${nbsp}100%-120%  80%</br>
// ${nbsp}120%-150%  90%</br>
// ${nbsp}150%-200%  95%</br>
// ${nbsp}200%以上  100%</br>
// 备注：以道路实采-大批为例</br>
export const zlScoreContent = `
  ${nbsp}指标描述：每个人的实际质量（验收一次缺陷率）对比产线标准质量的情况得分</br>
  ${nbsp}基本计算逻辑：</br>
  ${nbsp}${nbsp}1.达标比=产线标准质量/实际质量</br>
  ${nbsp}${nbsp}2.权重(40)*达标比系数=质量得分</br>
  ${nbsp}达标比与达标比系数对应关系：</br>
  ${nbsp}${nbsp}50%以下  20%</br>
  ${nbsp}${nbsp}50%-60%  30%</br>
  ${nbsp}${nbsp}60%-70%  40%</br>
  ${nbsp}${nbsp}70%-80%  50%</br>
  ${nbsp}${nbsp}80%-90%  60%</br>
  ${nbsp}${nbsp}90%-100%  70%</br>
  ${nbsp}${nbsp}100%-120%  80%</br>
  ${nbsp}${nbsp}120%-150%  85%</br>
  ${nbsp}${nbsp}150%-170%  90%</br>
  ${nbsp}${nbsp}170%-200%  95%</br>
  ${nbsp}${nbsp}200%以上  100%</br>
`;
// 指标描述：每个人的实际有效时长对比产线标准时长（6.8h）的得分情况</br>
// 基本计算逻辑</br>
// ${nbsp}1.内业：实际有效时长=制作耗时=内业净用时+内检返修净用时+质检返修净用时</br>
// ${nbsp}&nbsp;&nbsp;&nbsp;中业：实际有效时长=作业耗时=中业编辑净用时+内检返修净用时+质检返修净用时</br>
// ${nbsp}2.达标比=实际时长/产线标准时长（6.8h）</br>
// ${nbsp}3.权重（10）*达标比系数=有效时长得分</br>
// 达标比与达标比系数对应关系：</br>
// ${nbsp}70%以下 20%</br>
// ${nbsp}70%-80% 40%</br>
// ${nbsp}80%-90% 60%</br>
// ${nbsp}90%-100% 80%</br>
// ${nbsp}100%-110% 90%</br>
// ${nbsp}110%-120% 95%</br>
// ${nbsp}120%以上 100%</br>
// 备注：以道路实采-大批为例</br>
export const hsScoreContent = `
${nbsp}指标描述：每个人的实际有效时长（当天出勤总耗时）对比产线标准时长的得分情况</br>
${nbsp}基本计算逻辑</br>
${nbsp}${nbsp}1.达标比=实际有效时长/产线标准耗时</br>
${nbsp}${nbsp}2.权重（10）*达标比系数=有效时长得分</br>
${nbsp}达标比与达标比系数对应关系：</br>
${nbsp}${nbsp}50%以下  20%</br>
${nbsp}${nbsp}50%-60%  30%</br>
${nbsp}${nbsp}60%-70%  40%</br>
${nbsp}${nbsp}70%-80%  50%</br>
${nbsp}${nbsp}80%-90%  60%</br>
${nbsp}${nbsp}90%-100%  70%</br>
${nbsp}${nbsp}100%-110%  80%</br>
${nbsp}${nbsp}110%-120%  85%</br>
${nbsp}${nbsp}120%-130%  90%</br>
${nbsp}${nbsp}130%-140%  95%</br>
${nbsp}${nbsp}140%以上  100%</br>
`;

